import './style.scss'
import { Button, Input, message, Modal } from 'antd'
import { FC, useEffect, useState } from 'react'
import * as HomeApi from '@/api/home'

interface IProps {
  open: boolean
  onCancel: () => void
  onSuccess: (text: string) => void
}

const AIGeneratorModal: FC<IProps> = (props) => {
  const { open, onCancel, onSuccess } = props
  const [loading, setLoading] = useState(false)
  const [text, setText] = useState('')
  const [result, setResult] = useState('')

  useEffect(() => {
    reGenerator()
  }, [open])

  const toGenerrator = async () => {
    if (!text) {
      return message.warning('请输入你的话题')
    }

    try {
      setLoading(true)
      const res = await HomeApi.answermeAigentext({ topic: text })
      if (res.text) {
        setResult(res.text)
      }
    } finally {
      setLoading(false)
    }
  }

  const reGenerator = () => {
    setText('')
    setResult('')
  }

  return (
    <>
      <Modal
        title="AI生成文案"
        className="commom-modal ai-generator-modal"
        footer={null}
        width={600}
        onCancel={() => onCancel?.()}
        open={open}
      >
        <div className="ai-generator-modal-content">
          {result ? (
            <>
              <div className="form-input">
                <div className="title">已生成以下文案</div>
                <div className="result">{result}</div>
              </div>

              <div className="footer-btns">
                <Button loading={loading} className="btn" onClick={reGenerator}>
                  重新生成
                </Button>
                <Button
                  loading={loading}
                  className="btn"
                  type="primary"
                  onClick={() => {
                    onSuccess(result || '')
                    onCancel()
                  }}
                >
                  使用该文案
                </Button>
              </div>
            </>
          ) : (
            <>
              <div className="form-input">
                <div className="title">请输入你的话题</div>
                <Input
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  className="input"
                  placeholder="例如：为什么打工人总是那么累"
                />
              </div>

              <div className="footer-btns">
                <Button loading={loading} className="btn btn-w100" type="primary" onClick={toGenerrator}>
                  {loading ? '文案生成中，请稍候...' : '开始生成'}
                </Button>
              </div>
            </>
          )}
        </div>
      </Modal>
    </>
  )
}

export default AIGeneratorModal
